var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"circular-image-container",style:({
    '--container-size': _vm.size + 'px',
    '--radius': _vm.radius + 'px',
    '--image-scale': _vm.imageScale.toString()
  })},[_c('div',{staticClass:"central-image"},[_c('v-img',{attrs:{"src":_vm.imageUrl,"width":"100%","height":"100%","contain":""}})],1),_c('div',{staticClass:"circles-container"},_vm._l((_vm.items),function(item,index){return _c('IconCircle',{key:index,attrs:{"index":index,"total":_vm.items.length,"icon":item.icon,"link":item.link,"tooltip":item.tooltip,"radius":_vm.radius,"is-mobile":_vm.isMobile}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }